if (!customElements.get('faq-list')) {
  customElements.define(
    'faq-list',
    class FaqList extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.categoryLabel = this.querySelector('[data-faq-category-label]');
        this.menu = this.querySelector('[data-faq-menu]');
        this.search = this.querySelector('[data-faq-search]');
        this.searchInput = this.querySelector('[data-faq-search-input]');
        this.empty = this.querySelector('[data-faq-empty]');
        this.activeCategory = 'all';

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onCategoryToggle = this.onCategoryToggle.bind(this);
        this.onCategorySelect = this.onCategorySelect.bind(this);
        this.onSearchToggle = this.onSearchToggle.bind(this);
        this.onSearchInput = this.onSearchInput.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.setupEventListeners();
        this.openItem(this.items[0], false);
      }

      disconnectedCallback() {
        for (const item of this.items) {
          item.querySelector('[data-faq-trigger]')?.removeEventListener('click', this.onTriggerClick);
        }

        this.querySelector('[data-faq-category-toggle]')?.removeEventListener('click', this.onCategoryToggle);
        this.querySelector('[data-faq-search-toggle]')?.removeEventListener('click', this.onSearchToggle);
        this.searchInput?.removeEventListener('input', this.onSearchInput);
        document.removeEventListener('click', this.onDocumentClick);

        for (const button of this.querySelectorAll('[data-faq-category]')) {
          button.removeEventListener('click', this.onCategorySelect);
        }
      }

      setupEventListeners() {
        for (const item of this.items) {
          item.querySelector('[data-faq-trigger]')?.addEventListener('click', this.onTriggerClick);
        }

        this.querySelector('[data-faq-category-toggle]')?.addEventListener('click', this.onCategoryToggle);
        this.querySelector('[data-faq-search-toggle]')?.addEventListener('click', this.onSearchToggle);
        this.searchInput?.addEventListener('input', this.onSearchInput);
        document.addEventListener('click', this.onDocumentClick);

        for (const button of this.querySelectorAll('[data-faq-category]')) {
          button.addEventListener('click', this.onCategorySelect);
        }
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.menu?.classList.remove('is-open');
        }
      }

      onCategoryToggle(event) {
        event.stopPropagation();
        this.menu?.classList.toggle('is-open');
      }

      onCategorySelect(event) {
        const button = event.currentTarget;
        this.activeCategory = button.dataset.faqCategory || 'all';

        if (this.categoryLabel) {
          this.categoryLabel.textContent = button.textContent.trim();
        }

        for (const option of this.querySelectorAll('[data-faq-category]')) {
          option.classList.toggle('is-active', option === button);
        }

        this.menu?.classList.remove('is-open');
        this.applyFilters();
      }

      onSearchToggle() {
        this.search?.classList.toggle('is-open');
        if (this.search?.classList.contains('is-open')) {
          this.searchInput?.focus();
        }
      }

      onSearchInput() {
        this.applyFilters();
      }

      onTriggerClick(event) {
        const item = event.currentTarget.closest('[data-faq-item]');
        if (!item) return;

        const isOpen = item.classList.contains('is-open');
        this.closeAll();
        if (!isOpen) {
          this.openItem(item);
        }
      }

      applyFilters() {
        const query = (this.searchInput?.value || '').trim().toLowerCase();
        let visibleCount = 0;

        for (const item of this.items) {
          const category = item.dataset.category || 'all';
          const text = item.textContent.toLowerCase();
          const matchesCategory = this.activeCategory === 'all' || category === this.activeCategory;
          const matchesQuery = query === '' || text.includes(query);
          const isVisible = matchesCategory && matchesQuery;

          item.classList.toggle('is-hidden', !isVisible);
          if (isVisible) visibleCount += 1;
        }

        this.empty?.classList.toggle('is-visible', visibleCount === 0);
      }

      closeAll() {
        for (const item of this.items) {
          item.classList.remove('is-open');
          const trigger = item.querySelector('[data-faq-trigger]');
          const panel = item.querySelector('[data-faq-panel]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.setAttribute('aria-hidden', 'true');
        }
      }

      openItem(item, focusTrigger = false) {
        if (!item) return;

        item.classList.add('is-open');
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'true');
          if (focusTrigger) trigger.focus();
        }
        if (panel) panel.setAttribute('aria-hidden', 'false');
      }
    }
  );
}
